import React from "react";
import { useTranslation } from "react-i18next";

const ProgressBar = (props) => {
  const { progress, isBlueProgress, styleClass } = props;
  const { t } = useTranslation();
  return (
    <>
      {isBlueProgress ? (
        <>
          <div
            className="progress blueProgressBar mb-30"
            role="progressbar"
            tabindex="0"
            aria-valuenow="75"
            aria-valuemin="0"
            aria-valuetext="75 percent"
            aria-valuemax="100"
          >
            <div
              className="progress-meter"
              style={{ width: `${progress}%` }}
            ></div>
            <div className="font-700 font-italic text-medium-gray mt-3">
              {`${
                progress <= 45
                  ? t("TMF.REVIEWPOPUP_UPLOADING")
                  : t("TMF.TEXT_SCANNING")
              } ${progress}%`}
            </div>
          </div>
        </>
      ) : (
        <div
          className={`progress-bar-wrapper ${styleClass || ""}`}
          style={styleClass && { width: "113px" }}
        >
          <div className="progress-bar">
            {`${
              progress <= 45
                ? t("TMF.REVIEWPOPUP_UPLOADING")
                : t("TMF.TEXT_SCANNING")
            } ${progress}%`}
          </div>
        </div>
      )}
    </>
  );
};

export default ProgressBar;
